import { render, staticRenderFns } from "./CosmetologCard.vue?vue&type=template&id=f064f7e0&scoped=true"
import script from "./CosmetologCard.vue?vue&type=script&lang=ts"
export * from "./CosmetologCard.vue?vue&type=script&lang=ts"
import style0 from "./CosmetologCard.vue?vue&type=style&index=0&id=f064f7e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f064f7e0",
  null
  
)

export default component.exports